import React, { useEffect, useState } from "react";
import axios from "axios";
import * as CONST from "../../includes/Constant";
import { Button, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import useAuthInfo from "../../../hooks/IsAdmin";
import { SD_GET_YEAR_DATA, SD_FY_MONTHS } from "../../includes/staticData";
import DashboardCard from "./boards/DashboardCard";
import StatsVendorPayments from "./stats/StatsVendorPayments";
import InvoiceStatusLineChart from "./graph/InvoiceStatusLineChart";
import TopPendingInvoices from "./stats/TopPendingInvoices";
import RaisedVsReceivedVsFee from "./graph/RaisedVsReceivedVsFee";
import FixedcostVsDedicatedBarChart from "./graph/FixedcostVsDedicatedBarChart";
import TopPayingClientsChart from "./graph/TopPayingClientsChart";
import TopPayingProjectsChart from "./graph/TopPayingProjectsChart";
import TopPayingVendorsChart from "./graph/TopPayingVendorsChart";
import ChartLatestVendorPayments from "./graph/ChartLatestVendorPayments"
import DepartmentReceivedVsRaised from "./stats/DepartmentReceivedVsRaised";
import SpentCards from "./boards/SpentCards";
const Dashboard = () => {
  const { isAdmin, eDepartmentId } = useAuthInfo();
  const { YEAR_LIST, CURRENT_FINANCIAL_YEAR, CURRENT_YEAR, SELECTED_YEAR } = SD_GET_YEAR_DATA();
  const [financialYear, setFinancialYear] = useState(null);
  const [raisedVsReceived, setRaisedVsReceived] = useState(null);
  const [dedicatedProjects, setDedicatedProjects] = useState(null);
  const [fixedcostProjects, setFixedcostProjects] = useState(null);
  const [vendorsSummery, setVendorsSummery] = useState(null);
  const [platformFeeSummary, setPlatformFeeSummary] = useState(null);
  const [gstSummaryAmount, setGSTSummaryAmount] = useState(null);
  const [fixedcostVsDedicated, setFixedcostVsDedicated] = useState(null);
  const [raisedAmount, setRaisedAmount] = useState(null);
  const [receivedAmount, setReceivedAmount] = useState(null);
  const [consideredAmount, setConsideredAmount] = useState(null);
  const [financialYears, setFinancialYears] = useState([]);
  const [searchParams, setSearchParams] = useState({});
  const [selectedYear, setSelectedYear] = useState(null);
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  const [loading, setLoading] = useState({
    raisedVsReceived: true,
    vendors: true,
    loadingFee: true,
    loadingDedicatedProject: true,
    loadingFixedcostProjects: true,
    considered: true,
  });

  useEffect(() => {
    if (YEAR_LIST) setFinancialYears(YEAR_LIST);
    if (CURRENT_FINANCIAL_YEAR) setCurrentFinancialYears(CURRENT_FINANCIAL_YEAR);
    if (SELECTED_YEAR) setSelectedYear(SELECTED_YEAR);
    if (isAdmin) fetchDepartmentList();

    const getDefaultMonth = () => {
      const jsCurrentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based, so add 1

      const fyMonthMap = {
        1: 10,  // Jan -> 10
        2: 11,  // Feb -> 11
        3: 12,  // Mar -> 12
        4: 1,   // Apr -> 1
        5: 2,   // May -> 2
        6: 3,   // Jun -> 3
        7: 4,   // Jul -> 4
        8: 5,   // Aug -> 5
        9: 6,   // Sep -> 6
        10: 7,  // Oct -> 7
        11: 8,  // Nov -> 8
        12: 9   // Dec -> 9
      };
      const financialMonth = fyMonthMap[jsCurrentMonth]; // Convert JS month to financial year month
      const defaultMonth = SD_FY_MONTHS.find((m) => m.value === financialMonth);
      //setCurrentMonth(defaultMonth);
      return defaultMonth || null;
    };
    //setSelectedMonth(getDefaultMonth());

    const defaultParams = {
      year: CURRENT_FINANCIAL_YEAR,
      department_id: isAdmin ? "" : eDepartmentId,
      //month: getDefaultMonth().value || "",
    };
    setSearchParams(defaultParams);
    fetchAllAPI(defaultParams);
  }, []);

  const fetchDepartmentList = async () => {
    try {
      const departmentResponse = await axios.get(CONST.GET_DEPARTMENT_LIST);
      if (departmentResponse.data.status === 'success') {
        const departments = departmentResponse.data.data.map(dept => ({
          value: dept.id,
          label: dept.name,
        }));
        setDepartmentList([{ value: '', label: 'Select' }, ...departments]);
      }
    } catch (error) {
      toast.error('Error fetching departments');
    }
  };

  const fetchRaisedVsReceived = async (params) => {

    setLoading(prev => ({ ...prev, raisedVsReceived: true }));
    try {
      const res = await axios.get(CONST.DASH_RAISED_VS_RECEIVED, { params });
      setRaisedVsReceived({
        totalRaised: res.data.total_raised,
        totalReceived: res.data.total_received
      });
    } catch (err) {
      console.error("Error fetching raised vs received data");
    } finally {
      setLoading(prev => ({ ...prev, raisedVsReceived: false }));
    }
  };
  /* FETCH VENDOR PAYMENTS */
  const fetchVendorsSummery = async (params) => {
    setLoading(prev => ({ ...prev, vendors: true }));
    try {
      const res = await axios.get(CONST.DASH_VENDOR_SUMMERY, { params });
      setVendorsSummery(res.data.data);
    } catch (err) {
      console.error("Error fetching vendor summary");
    } finally {
      setLoading(prev => ({ ...prev, vendors: false }));
    }
  };
  /* FETCH FEE SUMMARY */
  const fetchFeeSummary = async (params) => {
    setLoading(prev => ({ ...prev, loadingFee: true }));
    try {
      const res = await axios.get(CONST.DASH_PLATFORM_FEE_SUMMARY, { params });
      setPlatformFeeSummary(res.data.data);
    } catch (err) {
      console.error("Error fetching vendor summary");
    } finally {
      setLoading(prev => ({ ...prev, loadingFee: false }));
    }
  };
  /* FETCH GST SUMMARY */
  const fetchGSTSummary = async (params) => {
    setLoading(prev => ({ ...prev, loadingGSTSummary: true }));
    try {
      const res = await axios.get(CONST.DASH_GST_SUMMARY, { params });
      setGSTSummaryAmount(res.data.data);
    } catch (err) {
      console.error("Error fetching vendor summary");
    } finally {
      setLoading(prev => ({ ...prev, loadingGSTSummary: false }));
    }
  };
  const fetchFixedVsDedicated = async (params) => {

    setLoading(prev => ({ ...prev, loadingDedicatedProject: true }));
    setLoading(prev => ({ ...prev, loadingFixedcostProjects: true }));
    try {
      const res = await axios.get(CONST.DASH_FIXED_VS_DEDICATED, { params });
      setFixedcostVsDedicated({
        dedicated: res.data.dedicated,
        fixedcost: res.data.fixedcost
      });
      setDedicatedProjects({
        totalRaised: res.data.dedicated.total_raised,
        totalReceived: res.data.dedicated.total_received
      })
      setFixedcostProjects({
        totalRaised: res.data.fixedcost.total_raised,
        totalReceived: res.data.fixedcost.total_received
      })
    } catch (err) {
      console.error("Error fetching raised vs received data");
    } finally {
      setLoading(prev => ({ ...prev, loadingDedicatedProject: false }));
      setLoading(prev => ({ ...prev, loadingFixedcostProjects: false }));
    }
  };
  const fetchAllAPI = (params) => {
    fetchRaisedVsReceived(params);
    fetchVendorsSummery(params);
    fetchFixedVsDedicated(params);
    fetchFeeSummary(params);
    fetchGSTSummary(params);
  };
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);
  };

  const handleDepartmentChange = (selectedOption) => {
    setDepartments(selectedOption);
  };

  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };

  const handleSearch = () => {
    const newParams = {
      year: selectedYear ? selectedYear.value : "",
      department_id: isAdmin ? departments?.value || "" : eDepartmentId,
      month: selectedMonth ? selectedMonth.value : "",
    };
    setSearchParams(newParams);
    fetchAllAPI(newParams);
  };

  const handleReset = () => {

    setDepartments(null);
    setSelectedMonth("");
    const resetParams = {
      year: CURRENT_FINANCIAL_YEAR,
      department_id: isAdmin ? "" : eDepartmentId,
      month: "",
    };
    setSearchParams(resetParams);
    fetchAllAPI(resetParams);
  };

  return (
    <>
      <div className="container-fluid p-0">
        <Row className="justify-content-end">
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1"  >
            <Select
              options={financialYears}
              placeholder="Financial Year..."
              onChange={handleYearChange}
              value={selectedYear}
            />
          </Col>
          {isAdmin && (
            <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
              <Select
                options={departmentList}
                placeholder="Department..."
                onChange={handleDepartmentChange}
                value={departments}
              />
            </Col>
          )}

          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={SD_FY_MONTHS}
              placeholder="Select Month"
              onChange={handleMonthChange}
              value={selectedMonth}
            />
          </Col>

          <Col className="text-right">
            <Button variant="primary" onClick={handleSearch} className="me-2">
              <i className="bx bx-search-alt"></i> Search
            </Button>
            <Button variant="secondary" onClick={handleReset}>
              <i className="bx bx-x"></i> Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12}><hr /></Col>
        </Row>
        <div className="row mb-5">
          <div className="col-12 dashboard-cards">
            <Row className="">
              <DashboardCard
                title="Cashflow"
                values={[
                  { label: "Raised", amount: raisedVsReceived?.totalRaised },
                  { label: "Received", amount: raisedVsReceived?.totalReceived }
                ]}
                loading={loading.raisedVsReceived}
                view={'raisedVsReceived'}
                split={true}
                modal_size='xl'
                bg="bg-success-light"
              />
              <DashboardCard
                title="Dedicated Projects"
                values={[
                  { label: "Raised", amount: dedicatedProjects?.totalRaised },
                  { label: "Received", amount: dedicatedProjects?.totalReceived }
                ]}
                loading={loading.loadingDedicatedProject}
                view={'dedicatedMonthlySummary'}
                modal_size='lg'
                bg="bg-warning-light "
              />
              <DashboardCard
                title="Fixcost Projects"
                values={[
                  { label: "Raised", amount: fixedcostProjects?.totalRaised },
                  { label: "Received", amount: fixedcostProjects?.totalReceived }
                ]}
                loading={loading.loadingFixedcostProjects}
                view={'fixedcostMonthlySummary'}
                modal_size='lg'
                bg="bg-info-light"
              />
              <DashboardCard
                title="Vendors Payout"
                values={[
                  { label: "Monthly Payments", amount: vendorsSummery },
                ]}
                loading={loading.vendors}
                view={'vendorsSummery'}
                modal_size='lg'
                bg="bg-danger-light"
              />
              {/*  FEE */}
              <DashboardCard
                title="Platform Fee"
                values={[
                  { label: "Platform Fee", amount: platformFeeSummary },
                ]}
                loading={loading.loadingFee}
                view={'PlatformFeeSummary'}
                modal_size='lg'
                bg="bg-danger-light"
              />
              {/*  GST */}
              <DashboardCard
                title="GST"
                values={[
                  { label: "GST", amount: gstSummaryAmount },
                ]}
                loading={loading.loadingGSTSummary}
                view={'GSTSummaryDetails'}
                modal_size='lg'
                bg="bg-danger-light"
              />
              {/* SHOW SPENT CARDS */}
              {isAdmin && (
                <>{/* Department Wise Stats */}
                  <DepartmentReceivedVsRaised searchParams={searchParams} />
                </>
              )}
            </Row>
            <Row>
              <Col xs={12}>
                <InvoiceStatusLineChart searchParams={searchParams} />
              </Col>
              <Col sm={12} md={7} xl={7} >
                <TopPayingClientsChart searchParams={searchParams} bg="bg-success-light" />
              </Col>
              <Col sm={12} md={5} xl={5}>
                <RaisedVsReceivedVsFee searchParams={searchParams} />
              </Col>
              <Col xs={12}>
                <FixedcostVsDedicatedBarChart searchParams={searchParams} />
              </Col>
              <Col sm={12} md={6} xl={6}>
                <TopPayingVendorsChart searchParams={searchParams} />
              </Col>
              <Col sm={12} md={6} xl={6}>
                <ChartLatestVendorPayments searchParams={searchParams} />
              </Col>
              <Col sm={12} md={7} xl={7}>
                <TopPendingInvoices searchParams={searchParams} />
              </Col>
              <Col sm={12} md={5} xl={5}>
                <TopPayingProjectsChart searchParams={searchParams} />
              </Col>
            </Row>

          </div>
        </div>
      </div >
    </>
  );
};

export default Dashboard;
